import { useEffect } from 'react'

import { useComponentDidMount } from './didMount'

export const useEffectAfterMount = (action, watch) => {
  const isComponentMounted = useComponentDidMount()

  useEffect(() => {
    if (isComponentMounted) {
      action()
    }
  }, watch)
}
